import { ApolloClient, ApolloLink, createHttpLink, from } from '@apollo/client';
import { Env } from '../Env.ts';
import { buildPreRequestRefreshLink } from './PreRequestRefreshLink.ts';
import { configureCache } from './ConfigureCache.ts';
import { buildRefreshOnTokenExpiredLink } from './BuildRefreshOnTokenExpiredLink.ts';
import { onError } from '@apollo/client/link/error';

export function createApolloClient({
    onUnauthenticated,
}: {
    onUnauthenticated: () => void;
}) {
    /**
     * Este es un simple Link que, si detecta un error del tipo UNAUTHENTICATED,
     * avisa para arriba (ahora hacemos que vaya al login, en un futuro lo podemos mejorar)
     */
    const refreshOnAuthErrorLink = onError(({ graphQLErrors }) => {
        const unauthenticated = graphQLErrors?.some(
            (e) => e.extensions?.code === 'UNAUTHENTICATED'
        );

        if (unauthenticated) {
            onUnauthenticated();
        }
    });
    return new ApolloClient({
        cache: configureCache(),
        link: from([
            buildPreRequestRefreshLink(),
            buildRefreshOnTokenExpiredLink(),
            refreshOnAuthErrorLink,
            getConfigConCookies(),
        ]),
    });
}

function getConfigConCookies(): ApolloLink {
    return createHttpLink({
        uri: Env.GATEWAY_URL,
        credentials: 'include',
    });
}
